import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import fallbackImage from "../../../img/default-event-banner.jpg";
import { useEventParticipationSubmission } from "../../../context/EventParticipationSubmissionManager";
import Loading from "../../../components/Loading";

function EventParticipationSubmissionSidebarLayout({ children }) {
    const { event } = useEventParticipationSubmission();

    if(!event) {
        return (
            <div className="background-black">
                <div className="d-flex flex-column justify-content-center w-100">
                    <Loading />
                </div>
            </div>
        );
    }

    return (
        <div className="min-vh-100">
            <div className="position-absolute top-0 left-0 p-3 z-index-1">
                <div className="w-100 flex-grow-1">
                    <Link to={ `/event/${event.id}` } className="back-button text-white text-decoration-none font-weight-500 h4">
                        <i className="fa-regular fa-chevron-left mr-2"/> Terug naar evenement
                    </Link>
                </div>
            </div>
            
            <div className="d-flex flex-column flex-md-row h-100 min-vh-100">
                <div className="w-100 h-300px h-md-100" style={{ 
                    backgroundImage: `url(${event.banner?.url || fallbackImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    minHeight: "300px",
                    position: "relative"
                }}>
                    {event.logo?.url && (
                        <img 
                            src={event.logo.url} 
                            alt="Event Logo" 
                            style={{ 
                                position: "absolute", 
                                top: "33%", 
                                left: "50%", 
                                transform: "translate(-50%, -50%)", 
                                width: "60%",
                                maxWidth: "400px",
                                maxHeight: "80%" 
                            }} 
                        />
                    )}
                </div>
                
                <div className="w-100 h-100 background-black d-flex justify-content-center" style={{ minWidth: "40%" }}>
                    <div className="d-flex flex-column justify-content-center align-items-center h-100 py-4 px-3">
                        <div className="w-100 max-w-450">
                            { children }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

EventParticipationSubmissionSidebarLayout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default React.memo(EventParticipationSubmissionSidebarLayout);
